import { CallStatusDefault } from '../../models';
import { IHistorical, IHistoricalData, ILog, LogVM } from './model';

export const IHistoricalDataDefault = <T extends ILog> (): IHistoricalData<T> => ({
  total: 0,
  logs: []
});

export const IHistoricalDefault = <T extends ILog> (): IHistorical<T> => ({
  total: 0,
  logs: [],
  latestStatus: {...CallStatusDefault},
  moreStatus: {...CallStatusDefault}
});

export const LogVMDefault: LogVM = {
  date: new Date(),
  title: '',
  subtitle: ''
}

export const mapLogDefault =  <T extends ILog>(log: T): LogVM => ({
  ...LogVMDefault,
  date: new Date(log.datetime)
});